import MoreIcon from '@/assets/more.svg?react'
import clsx from 'clsx'
import type { HTMLAttributes, MouseEvent, ReactNode } from 'react'
import { default as ActionButton, type ActionButtonProps } from '../ActionButton'
import DropdownMenu from '../DropdownMenu/DropdownMenu'
import type { MenuItemData } from '../DropdownMenu/types'
import styles from './CommentActionBar.module.css'

export interface CommentActionBarProps extends HTMLAttributes<HTMLDivElement> {
	children?: ReactNode
	menu: MenuItemData[]
	onMenuSelect: (menuId: string) => void
}

export default function CommentActionBar({
	children,
	className,
	menu,
	onClick,
	onMenuSelect,
	...props
}: CommentActionBarProps) {
	const handleClick = (event: MouseEvent<HTMLDivElement>) => {
		event.stopPropagation()
		onClick?.(event)
	}

	return (
		<div onClick={handleClick} {...props} className={clsx(styles.root, className)}>
			{children}
			<DropdownMenu
				data={menu}
				onSelect={onMenuSelect}
				position="bottom-end"
				renderTrigger={(triggerProps) => (
					<ActionButton
						tooltip="更多操作"
						icon={<MoreIcon width="20px" height="20px" />}
						{...(triggerProps as ActionButtonProps)}
					/>
				)}
			/>
		</div>
	)
}
